import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// Spielernamen (users-Collection) einmal je Sitzung laden und im Speicher
// halten. Tippseite, Ranking, Bonusfragen und Hall of Fame brauchen dieselben
// Namen – vorher hat jede Seite die Docs erneut gelesen (N Reads je Besuch).
// Nach 30 Minuten wird neu geladen, damit neue Spieler und geänderte Namen
// ankommen.

const HALTBARKEIT_MS = 30 * 60 * 1000;
let cache = null;        // { [uid]: { displayName, favoritenTeam } }
let geladenAm = 0;
let laufend = null;      // laufendes Promise, damit parallele Aufrufe nur einmal lesen

export async function ladeSpielerNamen(erzwingen = false) {
  const frisch = cache && (Date.now() - geladenAm) < HALTBARKEIT_MS;
  if (frisch && !erzwingen) return cache;
  if (laufend) return laufend;
  laufend = getDocs(collection(db, 'users')).then(snap => {
    const map = {};
    snap.forEach(d => {
      const u = d.data();
      map[d.id] = { displayName: u.displayName || 'Unbekannt', favoritenTeam: u.favoritenTeam || null };
    });
    cache = map;
    geladenAm = Date.now();
    laufend = null;
    return map;
  }).catch(error => {
    laufend = null;
    throw error;
  });
  return laufend;
}

export function spielerName(map, uid) {
  return map?.[uid]?.displayName || 'Unbekannt';
}
